import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { Chip } from "@outpave/ds";
import { Inline } from "components/layout/reusableLayouts";
import type { AllocationType } from "hooks/useAllocationTypes";

/** How the server spells an allocation type with no ledger mapping. */
export const NOT_MAPPED = "none";

export const isSyncedType = (type: AllocationType) =>
  !!type.integrationEntity && type.integrationEntity !== NOT_MAPPED;

interface AllocationTypeControlsProps {
  allocationType: AllocationType;
}

/** The selected type's markers: whether it syncs and whether a custom field collects it. */
const AllocationTypeControls: React.FC<AllocationTypeControlsProps> = ({
  allocationType,
}) => {
  const { t } = useTranslation();

  return (
    <Inline
      gap="var(--space-3)"
      align="center"
      data-type-controls
      sx={{ marginLeft: "auto" }}
    >
      {isSyncedType(allocationType) && (
        <Tooltip title={t("SyncedFromAccountingSystem")} placement="top">
          <span>
            <Chip size="sm" tone="positive">
              {t("Synced")}
            </Chip>
          </span>
        </Tooltip>
      )}
      {allocationType.isLinkedCustomField && (
        <Tooltip title={t("MappedToCustomField")} placement="top">
          <span>
            <Chip size="sm" tone="info">
              {t("Custom Field")}
            </Chip>
          </span>
        </Tooltip>
      )}
    </Inline>
  );
};

export default AllocationTypeControls;
